import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import { AddCircleIcon } from 'refactored/ui/icons';
import { useSoFormStepsApi } from 'refactored/features/soForm/SoForm.context';
import { useTranslation } from 'react-i18next';

const IconContainer = styled.div`
  width: 20px;
  height: 20px;
  flex: none;
  order: 0;
  flex-grow: 0;
  display: flex;
`;

const TextContainer = styled.div`
  /* Container */

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

  height: 16px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  width: 220px;
  height: 16px;

  /* 14px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* primary/500 */

  color: #0140cd;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  cursor: pointer;
`;

const SoFormAddLoadButton = ({ className }) => {
  const stepsApi = useSoFormStepsApi();
  const { t } = useTranslation('Catalog');

  const onClick = useCallback(() => {
    stepsApi.addLoad();
  }, [stepsApi]);

  return (
    <button className={className} onClick={onClick}>
      <IconContainer>
        <AddCircleIcon />
      </IconContainer>
      <TextContainer>{t('configuration.loads.add_load')}</TextContainer>
    </button>
  );
};

SoFormAddLoadButton.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 0px;
  gap: 8px;

  height: 36px;

  border-radius: 4px;

  /* Inside auto layout */

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;

  background: transparent;
  border: none;
  outline: none;
  /* background: red; */
  /* border: 1px solid black; */
`;

export default styled(SoFormAddLoadButton)`
  ${regularCSS}
`;
